export const LIVE_ACTIVITY_PAGE_TABS = {
  interactions: 'interactions',
  conversations: 'conversations',
  users: 'users',
  cohorts: 'cohorts',
} as const;

export type LiveActivityPageTabs = (typeof LIVE_ACTIVITY_PAGE_TABS)[keyof typeof LIVE_ACTIVITY_PAGE_TABS];

export const LIVE_ACTIVITY_TAB_VALUES = Object.values(LIVE_ACTIVITY_PAGE_TABS) as LiveActivityPageTabs[];

export const LIVE_ACTIVITY_DEFAULT_PATH = '/live-activity/interactions';

export function getLiveActivitySectionPath(section: LiveActivityPageTabs): string {
  return `/live-activity/${section}`;
}

export function getLiveActivitySectionFromPath(pathname: string): LiveActivityPageTabs | null {
  const prefix = '/live-activity/';
  if (!pathname.startsWith(prefix)) return null;

  const section = pathname.slice(prefix.length);
  return LIVE_ACTIVITY_TAB_VALUES.includes(section as LiveActivityPageTabs)
    ? (section as LiveActivityPageTabs)
    : null;
}

export function isLiveActivityPath(pathname: string): boolean {
  return pathname === '/live-activity' || pathname.startsWith('/live-activity/');
}
